import React from "react";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Input, Space } from "antd";
import { CustomParams } from "../types";

interface CustomParamsInputProps {
  value?: CustomParams;
  onChange?: (value?: CustomParams) => void;
}

export const CustomParamsInput = (props: CustomParamsInputProps) => {
  const [params, setParams] = React.useState<CustomParams | undefined>(
    props.value
  );

  const remove = (key: string) => {
    const newParams = { ...params };
    delete newParams[key];
    if (Object.keys(newParams).length > 0) {
      setParams(newParams);
      props.onChange?.(newParams);
    } else {
      setParams(undefined);
      props.onChange?.(undefined);
    }
  };

  const add = () => {
    const newParams = { ...params };
    newParams[`key${Object.keys(newParams).length}`] = `value${
      Object.keys(newParams).length
    }`;
    setParams(newParams);
    props.onChange?.(newParams);
  };

  const onChange = (oldKey: string, key: string, value: string) => {
    const newParams = { ...params };
    delete newParams[oldKey];
    newParams[key] = value;
    setParams(newParams);
    props.onChange?.(newParams);
  };

  return (
    <Space direction="vertical">
      {params &&
        Object.entries(params).map(([key, value], index) => (
          <Space key={index} direction="horizontal" align="baseline">
            <Input
              placeholder="Key"
              value={key}
              onChange={(e) => onChange(key, e.target.value, value)}
            />
            <Input
              placeholder="Value"
              value={value}
              onChange={(e) => onChange(key, key, e.target.value)}
            />
            <MinusCircleOutlined
              
              onClick={remove.bind(null, key)}
            />
          </Space>
        ))}
      <Button icon={<PlusOutlined  />} onClick={add}>
        Add Custom Param
      </Button>
    </Space>
  );
};
